<script setup>
import RollingCapacityAnimationModal from './RollingCapacityAnimationModal.vue';
</script>

<template>
  <div :class="$style.content">
    <div :class="$style.content__section">
      <h3 :class="$style.content__section__title">
        Introducing Rolling Funding Capacity
      </h3>
      <p :class="$style.content__section__copy">
        Capital that replenishes as you repay. Use it to fund eligible business
        expenses - your available capacity grows back automatically with every
        payment.
      </p>
    </div>

    <div :class="$style.content__section">
      <h3 :class="$style.content__section__title">How it Works</h3>
      <RollingCapacityAnimationModal />
    </div>

    <div :class="$style.content__section">
      <h3 :class="$style.content__section__title">Find your best fit</h3>
      <p :class="$style.content__section__copy">
        First, compare Rolling Funding to Fixed Funding to find your best fit.
        Next, tell us about your needs and we'll connect you with a member of
        our team to unlock Rolling Funding Capacity for your business.
      </p>
    </div>
  </div>
</template>

<style lang="less" module>
.content {
  height: 534px;

  @media (max-height: 900px) {
    height: 478px;
  }
}

.content__section {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

body h3.content__section__title {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  font-family: @regular-font;
  color: #000;
  margin-right: 40px;
}

.content__section__copy {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: @regular-font;
  color: #000;
  margin-right: 40px;
}

@media (min-width: 900px) {
  .content {
    max-width: 600px;
  }
}
</style>
